import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import SuccessPopupModal from "../../components/SuccessPopupModal";
import { addUpdateBlog, GetBlogModal } from "../../../Services/Blog/BlogApi";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import { useAuth } from "../../../Context/AuthContext";
import { addUpdateBanner, getBanner } from "../../../Services/Banner/BannerApi";
import Text_Editor from "../Text_Editor";


const BannerAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth()
  const [stateOption, setStateOption] = useState([]);
  const [companyOption, setCompanyOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [talukaOption, setTalukaOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);

  const [bannerObj, setBannerObj] = useState({
    bannerImage:null,
    bannerKeyID:null,
    bannerSubTitle:null,
  bannerTitle:null,
  });

 
  useEffect(() => {
    if (modelRequestData?.Action === 'Update') {
      if (modelRequestData?.BannerKeyID !== null) {
        GetBlogModalData(modelRequestData.BannerKeyID);
      }
    }
  }, [modelRequestData?.Action]);


  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      bannerObj.bannerImage === null ||
      bannerObj.bannerImage === undefined ||
      bannerObj.bannerImage === "" ||

      bannerObj.bannerSubTitle === null ||
      bannerObj.bannerSubTitle === undefined ||
      bannerObj.bannerSubTitle === "" ||

      bannerObj.bannerTitle === null ||
      bannerObj.bannerTitle === undefined ||
      bannerObj.bannerTitle === "" 

     
    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }


    const apiParam = {
      bannerTitle: bannerObj.bannerTitle,
      bannerKeyID:modelRequestData.BannerKeyID,
      bannerSubTitle: bannerObj.bannerSubTitle,
      bannerImage: bannerObj.bannerImage,
      

    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = '/addUpdateBanner'; // Default URL for Adding Data

      const response = await addUpdateBanner(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null || modelRequestData.Action === undefined
              ? 'Banner Added Successfully!'
              : ' Banner Updated Successfully!'
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };


  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 204800) {
        alert("Image size should be 200KB or less.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setBannerObj(prev => ({
          ...prev,
          [fieldName]: reader.result, // set base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };


  const handleRemoveImage = (fieldName) => {
    setBannerObj(prev => ({
      ...prev,
      [fieldName]: null,
    }));
  };
  const GetBlogModalData = async (id) => {
    if (id === undefined) {
      return;
    }

    try {
      const data = await getBanner(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        const ModelData = data.data.responseData.data; // Assuming data is an array

        setBannerObj({
          ...bannerObj,
          bannerKeyID: ModelData.bannerKeyID,
          bannerTitle: ModelData.bannerTitle,
          bannerSubTitle: ModelData.bannerSubTitle,
          bannerImage: ModelData.bannerImage,
        
        

        });

      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error('Error fetching data: ', data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error in Customer : ', error);
    }
  };

  console.log(bannerObj.Title, 'kdjsgauhydsa');

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleTitleChange = (htmlContent) => {
    setBannerObj((obj) => ({
      ...obj,
      bannerTitle: htmlContent,
    }));
  };

  const handleSubTitleChange = (htmlContent) => {
    setBannerObj((obj) => ({
      ...obj,
      bannerSubTitle: htmlContent,
    }));
  };




  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="md"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <>
            <h4 className="text-center text-dark project-main-mode">
              {modelRequestData?.Action !== null
                ? "Update Banner"
                : modelRequestData?.Action === null
                  ? "Add Banner"
                  : ""}
            </h4>
          </>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                    Banner Title
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Text_Editor
                    editorState={bannerObj.bannerTitle}
                    handleContentChange={handleTitleChange}
                    maxLength={150}
                    minHeight="120px"
                  />

                  {error &&
                    (bannerObj.bannerTitle === null ||
                      bannerObj.bannerTitle === undefined ||
                      bannerObj.bannerTitle === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            
              
            </div>
            
          
          <div class="row">
          <div className="col-12 col-md-12 mb-2">
                <div>
                  <label htmlFor="bannerSubTitle" className="form-label">
                    Banner Sub Title
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Text_Editor
                    editorState={bannerObj.bannerSubTitle}
                    handleContentChange={handleSubTitleChange}
                    maxLength={150}
                    minHeight="120px"
                  />

                  {error &&
                    (bannerObj.bannerSubTitle === null ||
                      bannerObj.bannerSubTitle === undefined ||
                      bannerObj.bannerSubTitle === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
          </div>
          <div className="row">
              <div className="col-12 col-md-12 mb-2">
                <label className="form-label">Banner Image:
                <p className="small">Note:-(Upto 200kb) </p>
                </label>
                {bannerObj.bannerImage ? (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={bannerObj.bannerImage}
                      alt="Feature Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage("bannerImage")}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        background: "rgba(255,255,255,0.8)",
                        border: "none",
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: "bold",
                        padding: "2px 8px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, "bannerImage")}
                    className="form-control"
                  />
                )}
                  {error &&
                    (bannerObj.bannerImage === null ||
                      bannerObj.bannerImage === undefined ||
                      bannerObj.bannerImage === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
              </div>
            </div>
          
            



            {/* <div className="row"> */}
          </div>
         

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default BannerAddUpdateModal;




